//* Libraries imports
import { useMutation } from "@tanstack/react-query";
import { toast } from "sonner";

//* Config imports
import { API_URL, getAuthHeaders } from "@/config/api";

//* Types imports
import type { ISaleOutputDTO } from "@/schemas/sales";

type GenerateTokenParams = {
  id: string;
  phone?: string;
};

async function generateSaleToken({ id, phone }: GenerateTokenParams) {
  const response = await fetch(`${API_URL}/sales/${id}/token`, {
    method: "POST",
    headers: getAuthHeaders(),
    body: JSON.stringify({ phone }),
  });

  if (!response.ok) {
    const errorData = await response.json().catch(() => ({}));
    throw new Error(errorData.message || "Falha ao gerar token");
  }

  const result = await response.json();
  return (result.data || result) as ISaleOutputDTO;
}

export function useGenerateSaleToken() {
  return useMutation({
    mutationFn: generateSaleToken,
  });
}
